export const replaceSpacesWithUnderscores = (str: string): string =>
    str.replace(/ /g, '_')
